module.exports = __webpack_public_path__ + "assets/img/busy_7.73969d5f.png";